import { v4 as uuidv4 } from 'uuid';

export function ProductSellerName(props = {}) {
	return {
		componentName: 'ProductSellerName',
		componentId: uuidv4(),
		props: Object.assign(
			{
				markers: [],
				message: '{sellerName}',
			},
			props,
		),
	};
}
